module.exports = __webpack_public_path__ + "files/38eb8c26b7fed31ef584e98b04eea672.png";